import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';

export default function Form({
  defaultValues,
  schema,
  children,
  onSubmit,
  ...rest
}) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues,
    resolver: schema ? yupResolver(schema) : undefined,
  });

  const getErrors = useCallback(
    (path) => ({
      error: !!errors[path],
      helperText: errors[path] && errors[path].message,
    }),
    [errors]
  );

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)} {...rest}>
      {React.Children.map(children, (child) => {
        // Guard against falsy children (e.g. {cond ? <X/> : null}) so
        // callers can conditionally render siblings inside the form.
        if (!React.isValidElement(child)) return child;
        return child.props.name
          ? React.createElement(child.type, {
              ...{
                ...child.props,
                control,
                ...getErrors(child.props.name),
                key: child.props.name,
              },
            })
          : child;
      })}
    </form>
  );
}

Form.propTypes = {
  defaultValues: PropTypes.any,
  schema: PropTypes.any,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
};
